import React from "react";
import { Box } from "@mui/material";

import classes from "./landingBg.module.css";
import { images } from "../../../assets";
import UrbcLogoWhite from "../urbc-logo-white/urbc-logo-white";

const LandingBg = () => {
   return (
      <Box
         style={{ backgroundImage: `url(${images.landingBg})` }}
         className={classes.image}
      >
         <Box>
            <UrbcLogoWhite />
         </Box>
      </Box>
   );
};

export default LandingBg;
